var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLinkedInWhite = function SvgLinkedInWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.833.002H4.167A4.167 4.167 0 0 0 0 4.169v11.666c0 2.301 1.866 4.167 4.167 4.167h11.666A4.167 4.167 0 0 0 20 15.835V4.17C20 1.868 18.135.002 15.833.002M6.667 15.835h-2.5V6.67h2.5zM5.417 5.612a1.465 1.465 0 0 1-1.459-1.47c0-.812.654-1.47 1.459-1.47s1.458.658 1.458 1.47-.652 1.47-1.458 1.47m11.25 10.223h-2.5v-4.67c0-2.806-3.334-2.594-3.334 0v4.67h-2.5V6.67h2.5v1.47c1.164-2.155 5.834-2.314 5.834 2.064z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedInWhite);
export { ForwardRef as ReactComponent };